import { onDocumentReady } from "@theme/dom-events";
import { requestIdleCallback } from "@theme/scheduling";
import {
  buildSectionSelector,
  normalizeSectionId,
  sectionRenderer
} from "@theme/section-renderer";
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));
  if (!section || section.dataset.hydrated === "true") {
    return;
  }
  await sectionRenderer.renderSection(normalizedId, {
    cache: false,
    url,
    mode: "hydration"
  });
  section.dataset.hydrated = "true";
}
async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
export {
  hydrate
};
